import { useTranslation } from "react-i18next";

/**
 * Предупреждение о рисках (ТЗ §20).
 *
 * Обычный текст третьего уровня, а не красная плашка: ТЗ прямо просит не делать
 * из него огромный блок, но и не прятать. Стоит дважды — под доходностью и под
 * лентой сделок: оба блока говорят о прошлом результате, и оба читаются как
 * обещание, если рядом ничего не написано.
 *
 * Текст правится в админке (ТЗ §34). Пусто — формулировка по умолчанию из
 * i18n: робот без заполненного поля не должен остаться без предупреждения.
 */
export function Disclaimer({ text }: { text?: string | null | undefined }) {
  const { t } = useTranslation();
  return (
    <p className="px-1 text-micro leading-4 font-normal text-text-tertiary">
      {text ?? t("robots.disclaimer")}
    </p>
  );
}
